@if(error || erro403){
@if(erro403){
<app-no-access></app-no-access>

}@else {
<div class="alert alert-danger" role="alert">{{ error }}</div>
}
}@else {
<div class="col-12 mb-4">
    <form [formGroup]="signatarioForm" (ngSubmit)="onSubmit()">
        <!--  Assinatura Prncipal -->
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura 01 Principal (<span style="color: red;">obrigatório</span>)
                        </h4>
                        <p>Assinatua principal, de quem esta solicitando o documento.</p>
                    </div>

                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-4">
                                <div class="mb-3">
                                    <label for="nomeAssinaturaPrincipal">Nome Completo</label>
                                    <input formControlName="nomeAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="Nome" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.nomeAssinaturaPrincipal.errors &&
                                                signatarioForm.get('nomeAssinaturaPrincipal')?.touched,
                                              }">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.nomeAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-3">
                                    <label for="emailAssinaturaPrincipal">E-mail</label>
                                    <input formControlName="emailAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.emailAssinaturaPrincipal.errors &&
                                                signatarioForm.get('emailAssinaturaPrincipal')?.touched,
                                              }">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.emailAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-3">
                                    <label for="documentoAssinaturaPrincipal">CPF</label>
                                    <input formControlName="documentoAssinaturaPrincipal" type="text"
                                        class="form-control form-control-sm" placeholder="CPF" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.documentoAssinaturaPrincipal.errors &&
                                                signatarioForm.get('documentoAssinaturaPrincipal')?.touched,
                                              }" mask="000.000.000-00">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.documentoAssinaturaPrincipal.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <label for="tipoAssinaturaPrincipal">Tipo de assinatura:</label>
                            <div class="form-check col-md-4 mb-3">
                                <input formArrayName="tipoAssinaturaPrincipal" class="inputcomexcecoo form-check-input"
                                    type="checkbox" checked value="1" id="tipoAssinaturaPrincipal" required
                                    [checked]="true" [disabled]="true">
                                <div class="d-flex">

                                    <label class="form-check-label" for="invalidCheck">
                                        Assinatura
                                    </label>
                                    <div>

                                        <span
                                            ngbTooltip="Esse é o tipo mais comum de assinatura. Representa a concordância formal do signatário com o conteúdo do documento."
                                            class="badge rounded-pill bg-warning ms-1">Info</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <!-- END Assinatura Prncipal -->

        </div>

        <!-- Assinatura Segundaria 02 -->

        <div class="row">
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura 02 (<span style="color: red;">obrigatório</span>)</h4>

                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinatura02">Nome Completo</label>
                                    <input formControlName="nomeAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="Nome" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.nomeAssinatura02.errors &&
                                                signatarioForm.get('nomeAssinatura02')?.touched,
                                              }">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.nomeAssinatura02.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinatura02">E-mail</label>
                                    <input formControlName="emailAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.emailAssinatura02.errors &&
                                                signatarioForm.get('emailAssinatura02')?.touched,
                                              }">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.emailAssinatura02.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinatura02">CPF</label>
                                    <input formControlName="documentoAssinatura02" type="text"
                                        class="form-control form-control-sm" placeholder="CPF" [ngClass]="{
                                                'is-invalid':
                                                signatarioForm.controls.documentoAssinatura02.errors &&
                                                signatarioForm.get('documentoAssinatura02')?.touched,
                                              }" mask="000.000.000-00">
                                    <div class="invalid-feedback"
                                        *ngIf="signatarioForm.controls.documentoAssinatura02.errors">
                                        O campo é obrigatório.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <label for="tipoAssinatura02">Tipo de assinatura:</label>
                            <div class="form-check col-md-4 mb-3">
                                <input disabled="habilitarForm" formArrayName="tipoAssinatura02"
                                    class="inputcomexcecoo form-check-input" type="checkbox" checked value="1"
                                    id="tipoAssinatura02" required [checked]="true" [disabled]="true">
                                <div class="d-flex">

                                    <label class="form-check-label" for="invalidCheck">
                                        Assinatura
                                    </label>
                                    <div>

                                        <span
                                            ngbTooltip="Esse é o tipo mais comum de assinatura. Representa a concordância formal do signatário com o conteúdo do documento."
                                            class="badge rounded-pill bg-warning ms-1">Info</span>
                                    </div>
                                </div>
                            </div>
                            <p></p>
                            <p></p>
                        </div>

                    </div>
                </div>
                <!-- end card -->
            </div> <!-- end col -->
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura 03</h4>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinatura03">Nome Completo</label>
                                    <input formControlName="nomeAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="Nome">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinatura03">E-mail</label>
                                    <input formControlName="emailAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinatura03">CPF</label>
                                    <input formControlName="documentoAssinatura03" type="text"
                                        class="form-control form-control-sm" placeholder="CPF" mask="000.000.000-00">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <label for="validationCustom03">Tipo de assinatura:</label>

                            <div class="form-check col-md-12 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked3(4)"
                                    (change)="selecionarTipo3(4)" id="comoParte3" />
                                <label class="form-check-label" for="comoParte3">Como parte <span
                                        ngbTooltip="Também envolve a assinatura formal do documento, mas com ênfase de que o signatário é uma das partes principais do contrato."
                                        class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>

                            <div class="form-check col-md-12 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked3(5)"
                                    (change)="selecionarTipo3(5)" id="testemunha3" />
                                <label class="form-check-label" for="testemunha3">Testemunha <span
                                        ngbTooltip="A pessoa assina o documento somente para atestar que presenciou a assinatura das partes principais."
                                        class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Assinatura 04</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="nomeAssinatura04">Nome Completo</label>
                                    <input formControlName="nomeAssinatura04" type="text"
                                        class="form-control form-control-sm" placeholder="Nome">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="emailAssinatura04">E-mail</label>
                                    <input formControlName="emailAssinatura04" type="text"
                                        class="form-control form-control-sm" placeholder="E-mail">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="mb-3">
                                    <label for="documentoAssinatura04">CPF</label>
                                    <input formControlName="documentoAssinatura04" type="text"
                                        class="form-control form-control-sm" placeholder="CPF" mask="000.000.000-00">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <label for="validationCustom04">Tipo de assinatura:</label>
                            <div class="form-check col-md-12 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked4(4)"
                                    (change)="selecionarTipo4(4)" id="comoParte4" />
                                <label class="form-check-label" for="comoParte4">Como parte<span
                                        ngbTooltip="Também envolve a assinatura formal do documento, mas com ênfase de que o signatário é uma das partes principais do contrato."
                                        class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>

                            <div class="form-check col-md-12 mb-3">
                                <input type="checkbox" class="form-check-input" [checked]="isChecked4(5)"
                                    (change)="selecionarTipo4(5)" id="comoParte4" />
                                <label class="form-check-label" for="comoParte4">Testemunha<span
                                        ngbTooltip="A pessoa assina o documento somente para atestar que presenciou a assinatura das partes principais."
                                        class="badge rounded-pill bg-warning ms-1">Info</span></label>
                            </div>
                        </div>


                    </div>
                </div>
                <!-- end card -->
            </div>
        </div>

        <!-- END Assinatura Segundaria 02 -->

        <!-- Assinatura Segundaria 03 -->

        <div class="row">
            <div class="col-12 d-flex">
                @if(isLoading){
                <button type="button" class="btn btn-light waves-effect">
                    <i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> Trabalhando
                </button>
                }@else{
                <button [disabled]="habilitarForm" type="submit" class="btn btn-info waves-effect waves-light d-flex">
                    <i class=" mt-1 bx bx-user-plus d-block font-size-16 me-3"></i> Adicionar signatários
                </button>
                }
            </div>
        </div>

        <!-- Assinatura Segundaria 03 -->
    </form>
</div>
}